import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { fromEvent, merge, Subscription, timer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IdleTimeoutService implements OnDestroy {

  private idleTime =  30 * 60 * 1000;

  private activitySubscription!: Subscription;
  private timerSubscription!: Subscription;

  constructor(
    private router: Router,
    private ngZone: NgZone
  ) { }

  startWatching(): void {

    this.ngZone.runOutsideAngular(() => {

      const activityEvents = merge(
        fromEvent(window, 'mousemove'),
        fromEvent(window, 'click'),
        fromEvent(window, 'keypress'),
        fromEvent(window, 'scroll')
      );

      this.activitySubscription = activityEvents.subscribe(() => {
        this.resetTimer();
      });

      this.resetTimer();
    });
  }

  resetTimer(): void {

    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }

    this.timerSubscription = timer(this.idleTime).subscribe(() => {

      this.ngZone.run(() => {
        this.logout();
      });

    });
  }

  logout(): void {

    this.showToast('Session expired due to inactivity');

    localStorage.clear();
    sessionStorage.clear();

    setTimeout(() => {
      this.router.navigate(['/login']);
    }, 2000);
  }

  showToast(message: string): void {

    const toast = document.createElement('div');

    toast.innerText = message;

    toast.style.position = 'fixed';
    toast.style.top = '20px';
    toast.style.right = '20px';
    toast.style.background = '#d32f2f';
    toast.style.color = 'white';
    toast.style.padding = '12px 20px';
    toast.style.borderRadius = '6px';
    toast.style.fontSize = '14px';
    toast.style.zIndex = '9999';
    toast.style.boxShadow = '0 2px 10px rgba(0,0,0,0.2)';

    document.body.appendChild(toast);

    setTimeout(() => {
      toast.remove();
    }, 5000);
  }

  ngOnDestroy(): void {

   if (this.activitySubscription) {
  this.activitySubscription.unsubscribe();
}

if (this.timerSubscription) {
  this.timerSubscription.unsubscribe();
}
  }
}